module.exports = __webpack_public_path__ + "media/images/icon__predict@3x-269e3782ccb779c98b91e7a50decf5a4.png";